import { createSelector } from 'reselect';
import ConsignmentParticularsColumns from '../../containers/ConsignmentParticularsColumns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state.reporting.CONSIGNMENT_PARTICULARS.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.CONSIGNMENT_PARTICULARS.isLoading;

export const getData =
  ReportDefinitions.CONSIGNMENT_PARTICULARS.getDataFunction();

export const getColumns =
  createSelector(getData, ConsignmentParticularsColumns);
